import InfoRow from "../InfoRow";
import { useAppContext } from "../../_context";

const LocationInfo = ({ location, asLink = true }) => {
  const [{ tx }] = useAppContext();

  return (
    <InfoRow icon="location" label={tx["Location"]}>
      {asLink ? (
        <a
          href={`https://www.google.com/maps/@${location.lat},${location.lng},14z`}
          className="text-primary fw-bold"
          target="_blank"
          rel="noreferrer">
          {location.address}
        </a>
      ) : (
        location.address
      )}
    </InfoRow>
  );
};

export default LocationInfo;
